import React from 'react';
import {styled} from "@mui/system";
import MainPageButton from './MainPageButton';
import CreateRoomButton from './CreateRoomButton';
import ServerButton from './ServerButton';
import { connect } from 'react-redux';
const MainContainer=styled('div')({
    width:'72px',
    height:'100%',
    display:'flex',
    flexDirection:"column",
    alignItems:'center',
    backgroundColor:'#111214'
})

const SideBar = ({ servers }) => {
  return (<MainContainer>
    <MainPageButton/>
    {servers.map((server) => (
      <ServerButton key={server.id} server={server} />
    ))}
    <CreateRoomButton/>
  </MainContainer>
  )
}

const mapStoreStateToProps = ({ room }) => ({
  servers: room.servers,
});

export default connect(mapStoreStateToProps)(SideBar)
